import { render, staticRenderFns } from "./ImgPage.vue?vue&type=template&id=b448baba&scoped=true&"
import script from "./ImgPage.vue?vue&type=script&lang=js&"
export * from "./ImgPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b448baba",
  null
  
)

export default component.exports